import React from "react";

const CapacitySummary = ({
  selectedVeiculosCount,
  capacidadeTotalSelecionada,
  pesoDoPedidoNumber,
  capacityFeedback,
  formatDecimalPtBr,
}) => {
  if (
    selectedVeiculosCount === 0 &&
    !Number.isFinite(pesoDoPedidoNumber) &&
    !capacityFeedback
  ) {
    return null;
  }

  return (
    <div
      style={{
        marginBottom: 24,
        padding: 16,
        borderRadius: 12,
        background: "#f9fafb",
        border: "1px solid #e5e7eb",
      }}
    >
      <div style={{ display: "flex", flexDirection: "column", gap: 4, color: "#374151" }}>
        <span>
          Capacidade total selecionada:{" "}
          <strong>{formatDecimalPtBr(capacidadeTotalSelecionada) ?? "0"} kg</strong>
        </span>
        {Number.isFinite(pesoDoPedidoNumber) ? (
          <span>
            Peso do pedido:{" "}
            <strong>{formatDecimalPtBr(pesoDoPedidoNumber) ?? "0"} kg</strong>
          </span>
        ) : (
          <span>Peso do pedido nao informado.</span>
        )}
      </div>

      {capacityFeedback && (
        <div
          style={{
            marginTop: 12,
            padding: "12px 14px",
            borderRadius: 10,
            border: `1px solid ${capacityFeedback.borderColor}`,
            background: capacityFeedback.background,
            color: capacityFeedback.color,
          }}
        >
          <div style={{ fontWeight: 600, marginBottom: 4 }}>{capacityFeedback.title}</div>
          <div>{capacityFeedback.description}</div>
        </div>
      )}
    </div>
  );
};

export default CapacitySummary;
